module.exports = __webpack_public_path__ + "a9ff803c3ea24313fecd7f2ad71dfb5e.svg";